<app-top-navbar></app-top-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>